import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    USER: {},
    welfare: {},
    wnd: {
      nmlMax: false,
      fullScreen: false,
      settings: false
    },
    sysConfig: {
      closeType: 1,
      setAsAutoRun: 1,
      updateType: 0
    },
    txt: {
      appTitle: '易乐玩游戏盒子',
      close: '确定要退出易乐玩游戏盒子吗？',
      closeAll: '关闭客户端的同时将关闭所有正在运行的网页游戏，确定要关闭吗？',
      checkUpdate: '正在检测更新......',
      checkUpdateDone: '您当前是最新版本哦！',
      checkUpdateError: '更新失败了哦！',
      switchAccount: '确认要切换账号吗？',
      welfareDay: '今日已领取过，请明日再来。'
    },
    hasGameWnd: 0,
    wndModal: {
      zIndex: 91,
      num: 0
    },
    browserTitle: null,
    browserUrl: null,
    boxConfig: {},
    searchKey: '',
    showLogin: false,
    showRegister: false,
    headerGameTitle: [],
    ADSHALL: null,
    historyUpdate: 0,
    reFreshPageData: 0,
    shutdownData: {},
    clockData: [],
    isOpenAds: false,
    wndGameparams: [],
    wndGameGiftsparams: [],
    wndGameVistorparams: [],
    errMsg: {
      passport: [
        '账号长度为4-20位', // 0
        '账号证格式不合法', // 1
        '请输入账号', // 2
        '请输入6-16位密码', // 3
        '账号或者密码错误', // 4
        '请输入密码', // 5
        '密码输入有误', // 6
        '验证码由5位数字和字母组成' // 7
      ],
      phone: [
        '请输入11位手机号',
        '手机号格式不正确',
        '请输入短信校验码',
        '手机验证码错误',
        '请输入手机验证码'
      ],
      reg: [
        '帐号由4-20数字、字母或下划线组成',
        '密码不能为空',
        '请确认密码',
        '密码由6-16位数字、字母或特殊字符组成',
        '输入的密码不一致'
      ],
      agreement: '请先阅读并同意《盛天用户注册协议》'
    },
    showBind: false,
    isVistor: null
  },
  mutations: {
    STATEFN(state, data) {
      if (!data.dataType) return
      switch (data.dataType) {
        case 'user':
          state.USER = data
          break
        case 'welfare':
          state.welfare = data
          break
        case 'dialog':
          state.DIALOG = data
          break
      }
    },
    GAMESTATE(state, data) {
      if (data.dataType === 'push') {
        state.wndGameparams.push(data.data)
      } else if (data.dataType === 'dele') {
        let oldArray = state.wndGameparams
        oldArray.forEach(item => {
          if (item.game_window === data.data.game_window) {
            if (oldArray.indexOf(item) > -1) {
              let i = oldArray.indexOf(item)
              oldArray.splice(i, 1)
              state.wndGameparams = oldArray
            }
          }
        })
      }
    },
    GAMEGIFTSSTATE(state, data) {
      if (data.dataType === 'push') {
        state.wndGameGiftsparams.push(data.data)
      } else if (data.dataType === 'dele') {
        let oldArray = state.wndGameGiftsparams
        oldArray.forEach(item => {
          if (item.game_window === data.data.game_window) {
            if (oldArray.indexOf(item) > -1) {
              let i = oldArray.indexOf(item)
              oldArray.splice(i, 1)
              state.wndGameGiftsparams = oldArray
            }
          }
        })
      }
    },
    GAMEVISTORSTATE(state, data) {
      if (data.dataType === 'push') {
        state.wndGameVistorparams.push(data.data)
      } else if (data.dataType === 'dele') {
        let oldArray = state.wndGameVistorparams
        oldArray.forEach(item => {
          if (item.game_window === data.data.game_window) {
            if (oldArray.indexOf(item) > -1) {
              let i = oldArray.indexOf(item)
              oldArray.splice(i, 1)
              state.wndGameVistorparams = oldArray
            }
          }
        })
      }
    },
    DEVICETYPE(state, data) {
      state.BROWSER.DEVICETYPE = data
    },
    WNDSTATE(state, data) {
      for (let k in data) {
        state.wnd[k] = data[k]
      }
    },
    SYSCONFIG(state, data) {
      for (let k in data) {
        state.sysConfig[k] = data[k]
      }
    },
    FNSTATE(state, data) {
      for (let k in data) {
        state[k] = data[k] < 0 ? 0 : data[k]
      }
    },
    FNMODAL(state, data) {
      for (let k in data) {
        state.wndModal[k] = data[k] < 0 ? 0 : data[k]
      }
    },
    USERFN(state, data) {
      state.USER = data
    },
    DIALOG(state, data) {
      state.DIALOG = data
    },
    HISTORYUPDATE(state, data) {
      state.historyUpdate = data
    }
  },
  actions: {}
})
